// extracted by mini-css-extract-plugin
export default {"zero":"CellTypeMoney_zero__RIv4y","placeHolderShimmer":"CellTypeMoney_placeHolderShimmer__gb23A"};